import { Close, Edit } from "@mui/icons-material";
import { Button, Box, Tooltip, useTheme, useMediaQuery } from "@mui/material";

interface IHeaderActionsProps {
    isEditing: boolean;
}

export default function HeaderActions({ isEditing }: IHeaderActionsProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box
            sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                justifyContent: { xs: "flex-end", md: "center" },
                flexDirection: { xs: "column", sm: "row" },
                width: { xs: "100%", md: "auto" },
            }}
        >
            <Tooltip
                title={isEditing ? "Concluir edição" : "Editar informações"}
            >
                <Button
                    variant={"outlined"}
                    type="submit"
                    startIcon={isEditing ? <Close /> : <Edit />}
                    size={isMobile ? "small" : "medium"}
                    fullWidth={isMobile}
                >
                    {isEditing ? "Cancelar" : "Editar Cabeçalho"}
                </Button>
            </Tooltip>
        </Box>
    );
}
